
define(
	'Code25.CaterpartsGlobal.Main'
	, [
		'Code25.CaterpartsGlobal.Header','Code25.CaterpartsGlobal.Utils','Code25.CaterpartsGlobal.KeyMapping','Code25.CaterpartsGlobal.Balance','Code25.CaterpartsGlobal.Sidebar','Code25.CaterpartsGlobal.OpenOrders','Code25.CaterpartsGlobal.Categories','Code25.CaterpartsGlobal.PartsBook','VintenCloud.Downloads.Downloads','Code25.CaterpartsGlobal.Tracking','Code25.CaterpartsGlobal.AccountHold','Code25.CaterpartsGlobal.Related','VintenCloud.PdpCountDown.PdpCountDown','Code25.CaterpartsGlobal.Loader','Code25.CaterpartsGlobal.Quotes','Code25.CaterpartsGlobal.Cases','Code25.CaterpartsGlobal.Register','Code25.CaterpartsGlobal.SalesRep','Code25.CaterpartsGlobal.Facets','Code25.CaterpartsGlobal.Redirects','Code25.CaterpartsGlobal.PDPInformation','Code25.CaterpartsGlobal.OEMMatch','Code25.CaterpartsGlobal.Privacy','Code25.CaterpartsGlobal.Login','Code25.CaterpartsGlobal.CloseAccount','Code25.CaterpartsGlobal.App','Code25.CaterpartsGlobal.Shipping','Code25.CaterpartsGlobal.Segments','Code25.CaterpartsGlobal.FilterAddresses','Code25.CaterpartsGlobal.SO','Code25.CaterpartsGlobal.Addressio','Code25.CaterpartsGlobal.WhatsApp','Code25.CaterpartsGlobal.DeliveryCosts','Code25.CaterpartsGlobal.ProductLists','Code25.CaterpartsGlobal.Cart','Code25.CaterpartsGlobal.AdvSearch','Code25.CaterpartsGlobal.Payments'
	]
	, function (
		Header,Utils,KeyMapping,Balance,Sidebar,OpenOrders,Categories,PartsBook,Downloads,Tracking,AccountHold,Related,PdpCountDown,Loader,Quotes,Cases,Register,SalesRep,Facets,Redirects,PDPInformation,OEMMatch,Privacy,Login,CloseAccount,App,Shipping,Segments,FilterAddresses,SOFilter,Addressio,WhatsApp,DeliveryCosts,ProductLists,Cart,AdvSearch,Payments
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {

					Utils.mount(container);
					KeyMapping.mount(container);
					Sidebar.mount(container);
					Loader.mount(container);
					Quotes.mount(container);
					Redirects.mount(container);
					OEMMatch.mount(container);
					Login.mount(container);
					CloseAccount.mount(container);
					Header.mount(container);
					FilterAddresses.mount(container);
					WhatsApp.mount(container);
					DeliveryCosts.mount(container);
Categories.mount(container);

					if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
						//
						
						PartsBook.mount(container);
						Related.mount(container);
						PdpCountDown.mount(container);
						Facets.mount(container);
						PDPInformation.mount(container);
						Privacy.mount(container);
						App.mount(container);
						Segments.mount(container);
						Cart.mount(container);
						AdvSearch.mount(container);
					}

					if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {
						Balance.mount(container);
						OpenOrders.mount(container);
						Downloads.mount(container);
						Tracking.mount(container);
						Cases.mount(container);
						SalesRep.mount(container);
						SOFilter.mount(container);
						Addressio.mount(container);
						ProductLists.mount(container);
						Payments.mount(container);
					}

					if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
						AccountHold.mount(container);
						Register.mount(container);
						Shipping.mount(container);
						Addressio.mount(container);
						Payments.mount(container);
					}

					
				}

			}
		};
	});
